/**
 * 通用工具条组件
 */
export default class SimpleEditToolBar {
  constructor(callBack) {
    this.callback=callBack;
  }
  onAdd(map) {
    this._ul = this._createUi();
    return this._ul
  }
  onRemove() {
    this._ul.parentNode.removeChild(this._ul);
  }

  /**
   * 设置当前点的数量，根据数量自动改变按钮状态
   * @param size {number} 点数量
   * @param sizeRedo {number} 已撤销点数量
   */
  setPointLength(size,sizeRedo){
    this.liFinish.setAttribute("disabled",size <= 3);
    this.liUndo.setAttribute("disabled",size <= 0);
    this.liRedo.setAttribute("disabled",sizeRedo <= 0);
  }
 /**
   * 设置当前点的数量，根据数量自动改变按钮状态,画线使用
   * @param size {number} 点数量
   * @param sizeRedo {number} 已撤销点数量
   */
  setPointLengthLine(size,sizeRedo){
    this.liFinish.setAttribute("disabled",size <= 1);
    this.liUndo.setAttribute("disabled",size <= 0);
    this.liRedo.setAttribute("disabled",sizeRedo <= 0);
  }



  _createUi() {
    let ul = document.createElement("ul");
    ul.className = "mapboxgl-ctrl-drawArea mapboxgl-ctrl";
    ul.addEventListener("contextmenu", this._preventDefault);
    let liCancle = this._createLi("取消", "iconfont-map map-icon-quxiao");
    ul.appendChild(liCancle);
    liCancle.addEventListener("click", (e) => {
      e.stopPropagation();
      this.callback("cancel")
    })
    this.liUndo = this._createLi("撤销", "iconfont-map map-icon-chehui");
    this.liUndo.setAttribute("disabled",true);
    this.liUndo.addEventListener("click", (e) => {
      e.stopPropagation();
      this.callback("undo")
    })
    ul.appendChild(this.liUndo);
    this.liRedo = this._createLi("重做", "iconfont-map map-icon-zhongzuo");
    this.liRedo.setAttribute("disabled",true);
    ul.appendChild(this.liRedo);
    this.liRedo.addEventListener("click", (e) => {
      this.callback("redo")
    })
    let addPoint = this._createLi("加点", "iconfont-map map-icon-location");
    ul.appendChild(addPoint);
    addPoint.addEventListener("click", (e) => {
      e.stopPropagation();
      this.callback("addPoint")
    })
    this.liFinish = this._createLi("完成", "iconfont-map map-icon-wanchengchenggong");
    this.liFinish.setAttribute("disabled",true);
    ul.appendChild(this.liFinish);
    this.liFinish.addEventListener("click", (e) => {
      e.stopPropagation();
      this.callback("finish")
    })

    return ul;
  }

  _preventDefault(e) {
    e.preventDefault();
  }

  /**
   * 产生li标签
   * @private
   */
  _createLi(text, className) {
    let li = document.createElement("li");
    let span = document.createElement("span");
    span.className = className;
    li.appendChild(span);
    let div = document.createElement("div");
    div.innerText = text;
    li.appendChild(div);
    return li;
  }
}



// WEBPACK FOOTER //
// ./src/tool/control/SimpleEditToolBar.js